import Vue from 'vue'
import VueRouter from 'vue-router'
import NewHead from '@/components/newHead/newHead'
import Login from '@/components/login/login'
import Forget from '@/components/forget/forget'
import DownloadSection from '@/components/downloadSection/downloadSection'
import DownloadDetail from '@/components/downloadDetail/downloadDetail'
import ContactUs from '@/components/contactUs/contactUs'




//解决导航栏中的vue-router在3.0版本以上重复点击菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [


  {
    path: '/',
    name: 'first',
    component: resolve => require(["@/components/home/first.vue"], resolve),
  },
  {
    path: '/inform',
    name: 'inform',
    component: resolve => require(["@/components/notice/inform.vue"], resolve),
  },
  {
    path: '/information',
    name: 'information',
    component: resolve => require(["@/components/notice/information.vue"], resolve)
  },
  {
    path: '/curriculum',
    name: 'curriculum',
    component: resolve => require(["@/components/optimizing/curriculum.vue"], resolve),
  },
  {
    path: '/details',
    name: 'details',
    component: resolve => require(["@/components/optimizing/details.vue"], resolve)
  },
  {
    path: '/learn',
    name: 'learn',
    component: resolve => require(["@/components/study/learn.vue"], resolve),
  },
  {
    path: '/system',
    name: 'system',
    component: resolve => require(["@/components/study/system.vue"], resolve),
  },
  {
    path: '/profile',
    name: 'profile',
    component: resolve => require(["@/components/study/profile.vue"], resolve)
  },

  {
    path: '/lecturer',
    name: 'lecturer',
    component: resolve => require(["@/components/study/lecturer.vue"], resolve)
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: resolve => require(["@/components/study/certificate.vue"], resolve)
  },
  {
    path: '/exam',
    name: 'exam',
    component: resolve => require(["@/components/study/exam.vue"], resolve)
  },
  {
    path: '/answer',
    name: 'answer',
    component: resolve => require(["@/components/study/answer.vue"], resolve)
  },
  {
    path: '/policy',
    name: 'policy',
    component: resolve => require(["@/components/notice/policy.vue"], resolve),
  },
  {
    path: '/policyation',
    name: 'policyation',
    component: resolve => require(["@/components/notice/policyation.vue"], resolve)
  },
  {
    path: '/train',
    name: 'train',
    component: resolve => require(["@/components/study/train.vue"], resolve)
  },
  {
    path: '/dingbu',
    name: 'dingbu',
    component: resolve => require(["@/components/dingbu.vue"], resolve)
  }, {
    path: '/newHead',
    name: '新首页',
    component: NewHead
  }, {
    path: '/login',
    name: '登录',
    component: Login
  }, {
    path: '/forget',
    name: '忘记密码',
    component: Forget
  },
  {
    path: '/downloadSection',
    name: '下载中心',
    component: DownloadSection
  }, {
    path: '/downloadDetail',
    name: '下载详情',
    component: DownloadDetail
  },
  {
    path: '/contactUs',
    name: '联系我们',
    component: ContactUs
  },
]



const router = new VueRouter({
  routes
})

export default router